<script setup>
import {defineProps,computed} from "vue";
import {game} from "@/utils/config";

const type = computed(() => game.mos)
const props = defineProps({
  orderLst: {
    type: Array,
    default: () => [],
  }
})
</script>

<template>
  <el-card class="order-items" shadow="never" v-for="order in props.orderLst" :key="order.id">
    <template #header>
      <div class="order-items-header">
        <div class="order-sn">
          订单编号：{{ order.ordersn }}
        </div>
        <div class="order-state">
          <div :class="`order-state-item-${order.state === 1?'success':'cancel'}`">
            {{ order.state_text }}
          </div>
        </div>
      </div>
    </template>
    <div class="order-items-body">
      <div class="order-items-body-left">
        <el-image :src="type.icon"/>
      </div>
      <div class="order-items-body-right">
        <h4 class="order-product-name">{{  order?.goodsItems?.goods_name }}</h4>
        <div class="order-items-body-right-content">
          <span>支付里程：</span>{{ order.miles }}里程
        </div>
        <div class="order-items-body-right-content">
          <span>下单时间：</span>{{ order.create_time }}
        </div>
        <div class="order-items-body-right-content">
          <span>充值账户：</span>{{ order.mobile }}
        </div>
      </div>
    </div>
  </el-card>
</template>

<style scoped lang="less">



  .order-items {
    margin-bottom: 15px;
    background: #ffffff url("@/assets/images/order-body.png") no-repeat right bottom;
    background-size: 50px;

    /deep/ .el-card__header {
      padding: 10px;
    }

    .order-items-header {

      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: .8rem;

      .order-state-item-success {
        color: var(--el-color-warning);
      }

      .order-state-item-cancel {
        color: var(--el-color-info);
      }
    }

    .order-items-body {
      display: flex;
      align-items: center;

      .order-items-body-left {
        margin-right: 8px;
        background: #00502B;
        border-radius: 8px;
        padding: 10px;
        box-sizing: border-box;
      }

      .order-items-body-right {
        line-height: 1.75;

        .order-product-name {
          color: var(--view-copy-right-color);
        }

        .order-items-body-right-content {
          font-size: .8rem;
        }
      }
    }
  }
</style>
